import { useEffect } from "react";
import { ToggleButton, DecimalInput } from "components";
import { LabelledInput, LabelledSelect } from "../../../../Fields";
import { useInput } from "hooks";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveExtraSavingsTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const isUpTo = useInput(false);
  const type = useInput("$");
  const val = useInput("10.00");
  const isPurchase = useInput(true);
  const pVal = useInput("");
  const pType = useInput("");
  const suffix = useInput("");

  const typeData = [
    { label: "$", value: "$" },
    { label: "Unit", value: "Unit" },
  ];
  const typeData1 = [
    { label: "$", value: "$" },
    { label: "%", value: "%" },
  ];

  const formatFirstLine = (v, t) => {
    let result = "";
    switch (t) {
      case "$":
        result = `$${formatDollarValue(v)}`;
        break;
      case "%":
        result = `${v}%`;
        break;
      default:
        break;
    }
    return result ? ` ${result}` : "";
  };
  const formatPurchase = (isP, pV, pT) => {
    if (isP) {
      switch (pT) {
        case "$":
          return ` w/purchase/$${formatDollarValue(pV)}`;
        case "Unit":
          return ` w/purchase/${pV}`;
        default:
          return ` w/purchase/${pV}`;
      }
    }
    return "";
  };
  const handleUpdateValue = (isUT, v, t, isP, pv, pt, suf) => {
    onChange(
      `Save${isUT ? " Up To" : ""}${formatFirstLine(
        v,
        t
      )} on item${formatPurchase(isP, pv, pt)}${suf ? ` ${suf}` : ""}`
    );
  };

  useEffect(() => {
    if (value.startsWith("Save")) {
      let main = value.slice(4).trim();
      if (main.startsWith("Up To")) {
        main = main.slice(5).trim();
        isUpTo.setValue(true);
      } else {
        isUpTo.setValue(false);
      }
      const itIdx = main.indexOf("on item");
      const vt = main.slice(0, itIdx).trim();
      if (vt.startsWith("$")) {
        type.setValue("$");
        val.setValue(vt.slice(1));
      } else if (vt.endsWith("%")) {
        type.setValue("%");
        val.setValue(vt.slice(0, -1));
      }
      main = main.slice(itIdx + 7).trim();
      if (main.startsWith("w/purchase")) {
        main = main.slice(11).trim();
        const sufIdx = main.indexOf(" ");
        let vt = "";
        if (sufIdx > 0) {
          vt = main.slice(0, sufIdx).trim();
          suffix.setValue(main.slice(sufIdx).trim());
        } else {
          vt = main.trim();
          suffix.setValue("");
        }

        if (vt.startsWith("$")) {
          pType.setValue("$");
          pVal.setValue(vt.slice(1));
        } else if (vt.endsWith("Unit")) {
          pType.setValue("Unit");
          pVal.setValue(vt.slice(0, -4));
        }
      } else {
        suffix.setValue(main.trim());
      }
    }
    return () => { };
  }, [value]);

  return (
    <>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <div className="mt-3">Save</div>
        <ToggleButton className="mt-3 mx-2" style={{ width: '30%' }}
          label="Up To"
          value={isUpTo.value}
          onChange={(e) => {
            isUpTo.setValue(e);
            handleUpdateValue(e, val.value, type.value, isPurchase.value, pVal.value, pType.value, suffix.value);
          }}
        />

        {type.value === "$" ? (
          <DecimalInput labeled label="Value" placeholder="Value"
            value={val.value}
            onChange={(e) => {
              val.setValue(e);
              handleUpdateValue(isUpTo.value, e, type.value, isPurchase.value, pVal.value, pType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Value" placeholder="Value"
            allowclear="true" inputType="float" value={val.value}
            onChange={(e) => {
              val.setValue(e);
              handleUpdateValue(isUpTo.value, e, type.value, isPurchase.value, pVal.value, pType.value, suffix.value);
            }}
          />
        )}

        <LabelledSelect label="Type" className="mx-1" style={{ width: '90%' }}
          options={typeData1} value={type.value}
          onChange={(e) => {
            type.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, e, isPurchase.value, pVal.value, pType.value, suffix.value);
          }} />

        <div className="mt-3" style={{ width: '40%' }}>on item</div>
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <ToggleButton
          className="mt-3"
          label="w/purchase"
          value={isPurchase.value}
          onChange={(e) => {
            isPurchase.setValue(e);
            handleUpdateValue(
              isUpTo.value,
              val.value,
              type.value,
              e,
              pVal.value,
              pType.value,
              suffix.value
            );
          }}
        />

        {pType.value === "$" ? (
          <DecimalInput labeled label="Value" placeholder="Value" className="mx-2" style={{ width: '90%' }}
            value={pVal.value} disabled={!isPurchase.value}
            onChange={(e) => {
              pVal.setValue(e);
              handleUpdateValue(isUpTo.value, val.value, type.value, isPurchase.value, e, pType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Value" placeholder="Value" className="mx-2" style={{ width: '90%' }}
            allowclear="true" inputType="float" value={pVal.value} disabled={!isPurchase.value}
            onChange={(e) => {
              pVal.setValue(e);
              handleUpdateValue(isUpTo.value, val.value, type.value, isPurchase.value, e, pType.value, suffix.value);
            }}
          />
        )}

        <LabelledSelect label="Type" style={{ width: '90%' }} className="ml-1"
          options={typeData} value={pType.value || "Unit"} disabled={!isPurchase.value}
          onChange={(e) => {
            pType.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, type.value, isPurchase.value, pVal.value, e, suffix.value);
          }} />

        <LabelledInput label="Suffix" placeholder="Suffix" allowclear="true" value={suffix.value}
          onChange={(e) => {
            suffix.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, type.value, isPurchase.value, pVal.value, pType.value, e);
          }}
        />
      </div>
    </>
  );
};